import React from 'react';
import {
  calculatePoolEstimate,
  credits,
  HOUSE_FEE_PCT,
  percent,
  poolHealth,
  emptyPoolStats,
} from './nxlUtils';

function PoolBox({ market, poolStats, side, stake }) {
  const safePool = poolStats || emptyPoolStats();
  const health = poolHealth(safePool);
  const estimate = calculatePoolEstimate(safePool, side, stake);

  return (
    <div className="nxl-pool-panel">
      <div className="nxl-pool-header">
        <div>
          <p className="nxl-kicker">LIVE POOL</p>
          <h3>Current pool</h3>
        </div>

        <span className={`nxl-pool-health ${health.className}`}>
          {health.label}
        </span>
      </div>

      <p className="nxl-muted">{health.detail}</p>

      <div className="nxl-pool-total">
        <span>Total pool</span>
        <strong>{credits(safePool.credits_wagered)}</strong>
      </div>

      <div className="nxl-pool-sides">
        <div className={side === 'team_a' ? 'selected' : ''}>
          <span>{market?.team_a || 'Team A'}</span>
          <strong>{credits(safePool.team_a?.credits || 0)}</strong>
          <em>{safePool.team_a?.tickets || 0} tickets</em>
        </div>

        <div className={side === 'team_b' ? 'selected' : ''}>
          <span>{market?.team_b || 'Team B'}</span>
          <strong>{credits(safePool.team_b?.credits || 0)}</strong>
          <em>{safePool.team_b?.tickets || 0} tickets</em>
        </div>
      </div>

      <div className="nxl-pool-estimate">
        <div>
          <span>Projected pot</span>
          <strong>{credits(estimate.projectedTotalPool)}</strong>
        </div>

        <div>
          <span>House fee ({HOUSE_FEE_PCT}%)</span>
          <strong>{credits(estimate.projectedHouseFee)}</strong>
        </div>

        <div>
          <span>Winner pool</span>
          <strong>{credits(estimate.projectedWinnerPool)}</strong>
        </div>

        {estimate.hasOpposingAction ? (
          <>
            <div>
              <span>Your share</span>
              <strong>{percent(estimate.poolShare)}</strong>
            </div>

            <div className="nxl-quote-profit">
              <span>Est. payout</span>
              <strong>{credits(estimate.estimatedPayout)}</strong>
            </div>
          </>
        ) : (
          <div className="nxl-one-sided-warning">
            <strong>No opposing action yet.</strong>
            <span>Estimated payout is unavailable until both sides have credits.</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default PoolBox;